<template>
  <AppBanner>
    Edit Category
  </AppBanner>

  <template v-if="loading">
    <AppContentLoader
      :is-loading="loading"
      text="Loading category..."
    />
  </template>

  <template v-else-if="!category">
    <h1 class="flex items-center justify-center h-full">
      Unable to load category. Please try again.
    </h1>
  </template>

  <template v-else>
    <CategoryForm :model="category" />
  </template>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import { AppContentLoader } from '@/components/app';
import { AppBanner } from '@/components/banners';
import { CategoryForm } from '@/components/forms';

import { useHttp } from '@/composables';

const route = useRoute();

const loading = ref(true);
const category = ref(null);

onMounted(async () => {
  await loadCategory();
});

const loadCategory = async () => {
  const response = await useHttp().get(`/frameworks/${route.params.framework}/categories/${route.params.category}`);

  if (response.statusCode === HttpStatusCode.Ok) {
    category.value = response.data;
  }

  loading.value = false;
};
</script>
